module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 010.8418afdc.jpg";